const PARAM = "paymentId";

/** paymentId в адресе, как в референсном ProductDialog (?paymentId=): продукт
 * живёт в route-диалоге мимо роутера Next (docs/site/ROUTE-DIALOG.md),
 * поэтому параметр пишется history API напрямую, а не router.replace —
 * иначе роутер перерисовал бы страницу под диалогом. Нужен, чтобы
 * перезагрузка страницы посреди оплаты и возврат с редиректных провайдеров
 * возвращали покупателя к опросу статуса платежа. */
export function readPaymentIdParam(): string | null {
  if (typeof window === "undefined") return null;
  return new URLSearchParams(window.location.search).get(PARAM);
}

export function setPaymentIdParam(paymentId: string | null): void {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  if (paymentId) url.searchParams.set(PARAM, paymentId);
  else url.searchParams.delete(PARAM);
  window.history.replaceState(window.history.state, "", url.toString());
}

const PAYNET_PARAM = "paynet";

/** Флаг возврата со страницы Paynet (?paynet=success|cancel), кладётся
 * бэкендом в ссылки возврата (PaymentService.buildReturnUrl). Чистится тем
 * же history API, что и paymentId, по той же причине. */
export function setPaynetReturnParam(value: string | null): void {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  if (value) url.searchParams.set(PAYNET_PARAM, value);
  else url.searchParams.delete(PAYNET_PARAM);
  window.history.replaceState(window.history.state, "", url.toString());
}
